import React from 'react';
import { classIf } from '../../../data/utils';
import { xs_languageCode } from '../../..';

export default function StreamingButton(props) {
    const obj = props.obj;
    const index = props.index;
    const title = obj.loc?.[xs_languageCode] || (index + 1);

    return (
        <div className={"streaming-tv-button-channel " + (obj.pty) + classIf(index === props.current, 'selected')} onClick={() => props.setChannel(index)}>
            {obj.ico ?
                <img src={obj.ico} />
                :
                <>{title}</>
            }
        </div>    	
    );
}
